import React, { useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import Table from 'sama_global/components/Table';
import Add from 'sama_global/components/StyledButton/Add';
import {
  fetchSchoolDelete,
  REQUEST_SCHOOL_CREATE,
  REQUEST_SCHOOL_DELETE,
} from '@/modules/User';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { cleaRequest } from '@/modules/Requests';
import {
  fetchDelegates,
  REQUEST_GET_DELEGATES,
} from 'sama_global/modules/olimpic';

function Delegates({
  loadData,
  onDelete,
  requests,
  intl,
  clearRequest,
  olimpic,
}) {
  const columns = useMemo(
    () => [
      {
        name: '_id',
        label: 'id',
        options: {
          filter: false,
          searchable: false,
          display: 'excluded',
          sort: false,
        },
      },
      {
        name: 'name_en',
        label: intl.formatMessage({ id: 'NAME' }),
        options: {
          filter: false,
          sortThirdClickReset: true,
        },
      },
      {
        name: 'surname_en',
        label: intl.formatMessage({ id: 'SURNAME' }),
        options: {
          filter: false,
          sortThirdClickReset: true,
        },
      },
      {
        name: 'email',
        label: intl.formatMessage({ id: 'EMAIL' }),
        options: {
          filter: false,
          sortThirdClickReset: true,
        },
      },
      {
        name: 'phone',
        label: intl.formatMessage({ id: 'PHONE' }),
        options: {
          sortThirdClickReset: true,
        },
      },
      {
        name: 'school',
        label: intl.formatMessage({ id: 'COUNTRY' }),
        options: {
          sortThirdClickReset: true,
          customBodyRender: value => value && value.name,
        },
      },
    ],
    [intl]
  );

  const request = requests[REQUEST_GET_DELEGATES];

  const history = useHistory();

  useSnackbarListener(
    requests[REQUEST_SCHOOL_CREATE]?.success ? 'CREATED' : '',
    'success'
  );
  useSnackbarListener(
    requests[REQUEST_SCHOOL_DELETE]?.success ? 'DELETED' : '',
    'success'
  );
  useSnackbarListener(requests[REQUEST_SCHOOL_DELETE]?.errorMessage);
  useLoadbar(REQUEST_SCHOOL_CREATE);
  useLoadbar(REQUEST_SCHOOL_DELETE);
  useLoadbar(REQUEST_GET_DELEGATES);

  useEffect(() => {
    if (olimpic) {
      loadData(olimpic?._id);
    }
    return () => {
      clearRequest(REQUEST_SCHOOL_DELETE);
      clearRequest(REQUEST_SCHOOL_CREATE);
    };
  }, [olimpic]);

  const handleDelete = ({ data }) => {
    data.forEach(({ dataIndex }) => onDelete(request?.data[dataIndex]?._id));
  };

  const handleEdit = (row, { dataIndex }) => {
    history.push({
      pathname: `/delegates/edit/`,
      state: request.data[dataIndex],
    });
  };

  const handleCreate = () => history.push('/delegates/create');

  return (
    <Table
      columns={columns}
      data={request?.data}
      title="DELEGATES"
      options={{
        filter: false,
        customToolbar: () => (
          <Add title="CREATE_DELEGATE" onClick={handleCreate} />
        ),
        onRowClick: handleEdit,
        onRowsDelete: handleDelete,
      }}
    />
  );
}

Delegates.propTypes = {
  intl: PropTypes.object.isRequired,
  requests: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  loadData: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  clearRequest: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    requests: state.requests,
    user: state.user,
    olimpic: state.olimpic.sama,
  }),
  dispatch => ({
    loadData(id) {
      dispatch(fetchDelegates(id));
    },
    onDelete(id) {
      dispatch(fetchSchoolDelete(id));
    },
    clearRequest(name) {
      dispatch(cleaRequest(name));
    },
  })
)(injectIntl(Delegates));
